import { type ComponentsOverrides } from '@mui/material/styles'

export const overridesIconButton = (): ComponentsOverrides['MuiIconButton'] => ({
  sizeSmall: {
    // Pour être ISO Mui v4
    padding: '3px',
  },
})
